
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}},[_c('path',{attrs:{"d":"M15.857 14.476a.49.49 0 0 1 0 .691l-.691.691a.49.49 0 0 1-.691 0l-4.834-4.834a.463.463 0 0 1-.111-.181A5.96 5.96 0 0 1 5.999 12a6 6 0 0 1 0-12 6 6 0 0 1 6 6c0 1.322-.432 2.54-1.157 3.531a.483.483 0 0 1 .181.111l4.834 4.834zM6 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"}})])
      }
    
      }
    